import callApi from './crmService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/binding`;

export const checkBinding = () => callApi({
    method: 'POST',
    endpoint: `${basePath}/check-binding`
  });

export const sendSmsValidate = (mobile_info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/send-sms-validate`,
    body: mobile_info
  });

export const validateSmsAndBinding = (validate_info) => callApi({
    method: 'POST',
    endpoint: `${basePath}/validate-sms-and-binding`,
    body: validate_info
  });

export const checkMemberBind = (info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/check-member-bind`,
  body: info
});

export const sendSms = (mobile_info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/send-sms`,
  body: mobile_info
});

export const validateSms = (mobile_info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/validate-sms`,
  body: mobile_info
});

export const binding = (mobile_info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/binding`,
  body: mobile_info
});

export const register = (mobile_info) => callApi({
  method: 'POST',
  endpoint: `${basePath}/register`,
  body: mobile_info
});
